import {
    createMuiTheme
 } from '@material-ui/core/styles';

const mainTheme = createMuiTheme({
    palette: {
        // Orange
        primary: {
            light: '#ffb74d',
            main: '#f89534',
            dark: ' #ef6c00',
            contrastText: '#fff'
        },
        // Green
        secondary: {
            light: '#81c784',
            main: '#44b649',
            dark:  '#2e7d32',
            contrastText: '#fff'
        },
        // Blue
        tertiary: {
            light: '#03a9f4',
            main: '#2196f3',
            dark: '#1565c0',
            extraDark: '#0c1034',
            contrastText: '#fff'
        },
        // Red
        quaternary: {
            light: '#ef9a9a',
            main: '#f44336',
            dark: '#c62828',
            contrastText: '#fff'
        },
        // Gray
        quinary: {
            light: '#eee',
            main: ' #5c6771',
            dark: ' #424242',
            contrastText: '#fff'
        }
    },
    typography: {
        fontFamily: [
            'Encode Sans'
        ],
    },
    overrides: {
        MuiLink: {
            underlineHover: {
                transition: '.3s ease-in-out',
                '&:hover': {
                    textDecoration: 'none'
                }
            }
        },
        MuiTypography: {
            h1: {
                lineHeight: 'normal',
                fontSize: 72
            },
            h2: {
                lineHeight: 'normal',
                fontSize: 60
            },
            h3: {
                lineHeight: 'normal',
                fontSize: 48
            },
            h4: {
                lineHeight: 'normal',
                fontSize: 36
            },
            h5: {
                lineHeight: 'normal',
                fontSize: 24
            },
            h6: {
                lineHeight: 'normal',
                fontSize: 18
            }
        },
        MuiSvgIcon: {
            root: {
                transition: '.3s ease-in-out'
            }
        },
        MuiPopover: {
            paper: {
                '&::-webkit-scrollbar': {
                    width: 5
                },
                '&::-webkit-scrollbar-track': {
                    borderRadius: 10
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#aaa9ad',
                    borderRadius: 10,
                    transition: '.3s ease'
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: '#909090'
                }
            }
        },
        MuiGrid: {
            'spacing-xs-2': {
                width: 'calc(100% + 20px)',
                margin: -10
            }
        },
        MuiDialog: {
            paperWidthSm: {
                maxWidth: 600,
                padding: 20
            }
        },
        MuiDialogTitle: {
            root: {
                padding: 0
            }
        },
        MuiDialogContent: {
            root: {
                padding: 0
            }
        },
        MuiDialogContentText: {
            root: {
                'margin-bottom': 0
            }
        },
        MuiDialogActions: {
            root: {
                padding: 0,
                justifyContent: 'center'
            }
        },
        MuiTabs: {
            indicator: {
                backgroundColor: 'transparent',
                width: '0 !important'
            },
            root: {
                minHeight: 0,
                minWidth: 0
            }
        },
        MuiTab: {
            root: {
                minHeight: 0,
                minWidth: 0,
                maxWidth: '100%',
                padding: '8px 30px',
                '@media (min-width: 769px)': {
                    minWidth: 0
                }
            },
            wrapper: {
                display: 'flex',
                flexDirection: 'row'
            },
            labelIcon: {
                minHeight: 0,
                padding: 15,
                paddingTop: 15,
            }
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 769,
            md: 1025,
            lg: 1441,
            xl: 1921,
        }
    }
});

export default mainTheme

